/// <reference types="vite/client" />
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface PostTermsAndConditionsProps {
  response: any;
  isLoadingSendTerms: boolean;
  isSendTermsAndConditionsError: Error | null;
  sendTermsAndConditions: any;
  mutation: UseMutationResult<any, Error, postTermsAndConditionsReq>;
}

export interface postTermsAndConditionsReq {
  termsAndConditionsText: string;
}

export function postTermsAndConditions(): PostTermsAndConditionsProps {
  const mutation = useMutation({
    mutationFn: (arg: postTermsAndConditionsReq) => spiceroad.post('/v1/locs/instantfunding/acceptterms', arg).then((res) => res.data),
    mutationKey: ['postTermsAndConditions'],
  });

  return {
    response: mutation.data,
    isLoadingSendTerms: mutation.isPending,
    isSendTermsAndConditionsError: mutation.error,
    sendTermsAndConditions: mutation.mutateAsync,
    mutation,
  };
}

export default postTermsAndConditions;
